import {useTransition} from '@yandex-delivery/blocks'
import React, {memo} from 'react'
import {fetchLastOrderId, fetchRemoveLastOrderId} from 'src/shared/api'

import {ExistingOrderModal} from './ExistingOrderModal'

export const ExistingOrderDetector = memo(
  function ExistingOrderDetector(): React.ReactElement | null {
    const [{payload: orderId}, startTransition] = useTransition(
      fetchLastOrderId,
      {
        key: 'existing-order-detector',
      },
    )

    const closeHandler = () => {
      startTransition(fetchRemoveLastOrderId)
    }

    return orderId ? (
      <ExistingOrderModal onClose={closeHandler} orderId={orderId} />
    ) : null
  },
)
